import { CommonModule } from '@angular/common';
import {
  Component, EventEmitter, Input, Output
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { IRequestSessionParams } from '@sondermind/features/public-facing/session-request';
import { IrisButtonModule } from '@sondermind/iris/button';
import { IrisCardModule } from '@sondermind/iris/card';

@Component({
  selector: 'connect-card',
  standalone: true,
  imports: [
    CommonModule,
    IrisButtonModule,
    IrisCardModule,
    RouterModule
  ],
  templateUrl: './connect-card.component.html',
  styleUrls: ['./connect-card.component.scss']
})
export class ConnectCardComponent {
  @Input() ctaButtonText: string = 'Get started';
  @Input() firstName: string = 'this provider';
  @Input() paramsShareCode: string = '';
  @Input() paramsName: string = '';
  @Input() requestSessionQueryParams: IRequestSessionParams = null; // For tracking the user coming from .com site
  @Input() soonestAvailableDate: Date | null = null;
  @Input() accepting: boolean = true;
  @Output() requestASessionClicked: EventEmitter<void> = new EventEmitter<void>();

  onCtaClicked(): void {
    this.requestASessionClicked.emit();
  }
}
